import moment from 'moment';
import { Routine } from "./Routine";

export class RoutinePlan
{
    constructor( props = {} )
    {
        this.id = props.hasOwnProperty( 'id' ) ? props.id : null;
        this.status = props.hasOwnProperty( 'status' ) ? props.status : null;
        this.momentBeginnUtc = props.hasOwnProperty( 'beginnDate' ) ? moment( '' + props.beginnDate, 'YYYYMMDD' ).startOf( 'day').local() : null;
        this.beginnDate = props.beginnDate;
        this.momentEndUtc = props.hasOwnProperty( 'endDate' ) ? moment( '' + props.endDate, 'YYYYMMDD' ).endOf( 'day' ).local() : null;
        this.endDate = props.endDate;
        this.points = props.hasOwnProperty( 'points' ) ? +props.points : null;
        this.maxPoints = props.hasOwnProperty( 'maxPoints' ) ? +props.maxPoints : null;
        this.motivationBonus = props.hasOwnProperty( 'motivationBonus' ) ? +props.motivationBonus : null;
        this.checks = props.hasOwnProperty( 'checks' ) ? props.checks : [],
        this.routines = [];
        if ( props.hasOwnProperty( 'routines' ) && props.routines.length > 0 )
        {
            const routs = props.routines;
            for( let ri = 0; ri < routs.length; ri++ )
            {
                this.routines.push( new Routine( routs[ ri ] ) );
            }
        }
    }

    containsRoutine( routineId )
    {
        let contains = false;
        for ( let ri = 0; ri < this.routines.length; ri++ )
        {
            if ( this.routines[ ri ].id == routineId )
            {
                contains = true;
                break;
            }
        }
        return contains;
    }

    getDailyMorningRoutines()
    {
        return this.getRoutinesByCategoryId( Routine.CATEGORY_DAILY_MORNING );
    }

    getDailyMiddayRoutines()
    {
        return this.getRoutinesByCategoryId( Routine.CATEGORY_DAILY_MIDDAY );
    }

    getDailyEveningRoutines()
    {
        return this.getRoutinesByCategoryId( Routine.CATEGORY_DAILY_EVENING );
    }

    getDailyGoalRoutines()
    {
        return this.getRoutinesByCategoryId( Routine.CATEGORY_DAILY_GOAL );
    }

    getWeeklySportGoalRoutines()
    {
        return this.getRoutinesByCategoryId( Routine.CATEGORY_WEEKLY_GOAL_SPORT );
    }

    getWeeklyConsumeGoalRoutines()
    {
        return this.getRoutinesByCategoryId( Routine.CATEGORY_WEEKLY_GOAL_CONSUME );
    }

    getWeeklySpiritGoalRoutines()
    {
        return this.getRoutinesByCategoryId( Routine.CATEGORY_WEEKLY_GOAL_SPIRIT );
    }

    getWeeklyGoalRoutines()
    {
        return this.getRoutinesByCategoryId( Routine.CATEGORY_WEEKLY_GOAL );
    }

    getRoutinesByCategoryId( categoryId )
    {
        const rs = [];
        for ( let ri = 0; ri < this.routines.length; ri++ )
        {
            if ( this.routines[ ri ].categoryId === categoryId )
            {
                rs.push( this.routines[ ri ] );
            }
        }
        return rs;
    }
}
